var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 214.98 214.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffbf00;}.cls-2,.cls-3{opacity:0.2;}.cls-3,.cls-4{fill:#0A4A7C;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Message") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5703.32,5399.34a107.49,107.49,0,1,0-107.52,107.52A107.52,107.52,0,0,0,5703.32,5399.34Z",
    transform: "translate(-5488.34 -5291.88)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5595.8,5490.86a107.47,107.47,0,0,1-107.16-99.51q-.3,4-.3,8a107.49,107.49,0,1,0,215,0q0-4-.29-8A107.55,107.55,0,0,1,5595.8,5490.86Z",
    transform: "translate(-5488.34 -5291.88)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5595.8,5307.88A107.55,107.55,0,0,1,5703,5407.35c.19-2.65.29-5.31.29-8a107.49,107.49,0,0,0-215,0c0,2.7.1,5.36.3,8A107.48,107.48,0,0,1,5595.8,5307.88Z",
    transform: "translate(-5488.34 -5291.88)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5655.08,5441.37a2.51,2.51,0,0,1-2.46,2.46H5539a2.56,2.56,0,0,1-2.52-2.46v-59.28a42.93,42.93,0,0,0,5.34,5.1c11,8.46,22.14,17.1,32.88,26.1,5.82,4.86,13,10.8,21,10.8h.18c8,0,15.18-5.94,20.94-10.8,10.74-9,21.84-17.64,32.88-26.1a42.93,42.93,0,0,0,5.34-5.1v59.28Zm0-81.12c0,6.54-6.3,15.12-11.34,19.08-10.32,8.1-20.7,16.26-31,24.42-4.08,3.36-11.46,10.44-16.86,10.44h-.18c-5.4,0-12.84-7.08-16.92-10.44q-15.39-12.24-30.9-24.42c-7-5.52-11.4-13.14-11.4-22a2.61,2.61,0,0,1,2.52-2.46h113.58c2.94,0,2.46,3.42,2.46,5.34Zm9.9-2.88a12.37,12.37,0,0,0-12.36-12.3H5539a12.33,12.33,0,0,0-12.36,12.3v84a12.33,12.33,0,0,0,12.36,12.3h113.58a12.37,12.37,0,0,0,12.36-12.3v-84Z",
    transform: "translate(-5488.34 -5291.88)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueMessage);
export default __webpack_public_path__ + "static/media/Blue_Message.c2f7e9061f2850d16fa7ebfdbf8ef595.svg";
export { ForwardRef as ReactComponent };